/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: false, // Change this to false if you want the good'ol cursor
};

//Home Page
const greeting = {
  title: "Hii ! 👋",
  title2: "Shikhar Baniya",
  logo_name: "<Shikhar B />",
  nickname: "",
  full_name: "Shikhar Baniya",
  subTitle:
    "Front End Developer, Self Taught Programmer 🔥. Always learning.",
  resumeLink:
    "https://drive.google.com/file/d/1_2VkaW9sMDdQQraGEmq973fw00XYXllo/view?usp=sharing",
  mail: "baniyashikhar@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
 
  linkedin: "https://www.linkedin.com/in/shikhar-baniya",
  gmail: "baniyashikhar@gmail.com",
  facebook: "https://www.facebook.com/shikhar.baniya.5/",
  instagram: "https://www.instagram.com/_creocodigo_/",
};

const skills = {
  data: [
    {
      title: "Web Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Know how to develop highly interactive Front end / User Interfaces for your web applications",
        "⚡ Can build responsive website front end using ReactJS",
        "⚡ Can create application backend in Node & Express",
        "⚡ Know how to integrate of third party services such as Firebase."
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
  
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        // {
        //   skillName: "GraphQL",
        //   fontAwesomeClassname: "simple-icons:graphql",
        //   style: {
        //     color: "#DE33A6",
        //   },
        // },
        
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#f89820",
          },
        },
        
        {
          skillName: "Visual Basic",
          fontAwesomeClassname: "simple-icons:dot-net",
          style: {
            color: "#029FCE",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "jQuery",
          fontAwesomeClassname: "simple-icons:jquery",
          style: {
            color: "#0865A6",
          },
        },
        
        
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Databases and Server",
      fileName: "CloudInfraImg",
      skills: [
        
        "⚡ Experience hosting and managing websites",
       
      ],
      softwareSkills: [
        
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Sipna College of Enginnering and Technology",
      subtitle: "B.E. in Computer Science and Engineering",
      logo_path: "sipnalogo.png",
      alt_name: "SETI",
      duration: "2016 - 2020",
      descriptions: [
        "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        "⚡ I have also completed various online courses for Backend , Web , frameworks etc.",
        "⚡ I have implemented several projects based on what I've learnt under my Computer Engineering course. ",
      ],
      website_link: "https://sipnaengg.ac.in/",
    },
    {
      title: "Brijlal Biyani Junior Science College",
      subtitle: "H.S.C, Maharashtra",
      logo_path: "brijlal.png",
      alt_name: "brijlal",
      duration: "2014 - 2016",
      descriptions: [
        "⚡ I have secured 90% in H.S.C. Board Exams.",
      ],
      website_link: "https://sipnaengg.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "ASP.NET",
      subtitle: "Soham Consultants",
      logo_path: "asp.net_.jpg",
      certificate_link:
        "",
      alt_name: "ASP.NET",
      // color_code: "#2AAFED",
      color_code: "#5cc3ee",
    },
    {
      title: "Enterprise Java",
      subtitle: "Soham Consultants",
      logo_path: "java-logo.png",
      certificate_link:
        "",
      alt_name: "Java",
      color_code: "#f29010",
    },
    {
      title: "Python",
      subtitle: "MongoDB University",
      logo_path: "python.png",
      certificate_link:
        "",
      alt_name: "Python",
      // color_code: "#F6B808",
      color_code: "#fff",
    },
    {
      title: "Cyber Security",
      subtitle: "Sai Acuity Institute of Learning, Udemy",
      logo_path: "cyber.jpg",
      certificate_link:
        "",
      alt_name: "Cyber Security",
      color_code: "#2AAFED",
    },
    {
      title: "React JS",
      subtitle: "EdYoda Digital University",
      logo_path: "react.png",
      certificate_link:
        "",
      alt_name: "React JS",
      color_code: "#f05747",
    },
    {
      title: "AI with Python",
      subtitle: "Udemy",
      logo_path: "AI.png",
      certificate_link:
        "",
      alt_name: "AI with Python",
      color_code: "#1c2838",
    },
    // color_code: "#8C151599",
    // color_code: "#7A7A7A",
    // color_code: "#0C9D5899",
    // color_code: "#C5E2EE",
    // color_code: "#ffc475",
    // color_code: "#g",
    // color_code: "#ffbfae",
    // color_code: "#fffbf3",
    // color_code: "#b190b0",
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Workshop",
  description:
    "Since I am a self learner, I have done many projects on my own. I have also conducted workshops and volunteer work in my college time. Below are the details my work.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Assistant System Engineer",
          company: "TCS",
          company_url: "https://www.tcs.com/",
          logo_path: "tcs.jpg",
          duration: "Jan 2021 - Working",
          location: "Pune",
          description:"",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Internship",
      experiences: [
        {
          title: "Front End Developer",
          company: "Bip",
          company_url: "https://bip.so/",
          logo_path: "bip.svg",
          duration: "Sept 2020 - Nov 2020",
          location: "Work from Home",
          description:"In this internship, my role was to create UI/UX content for the company like mobile interface, contact page, Team page, SVG's, etc. I used Adobe Illustrator, Adobe Indesign, Figma for creating the wireframes and designs of the UX component and HTML, CSS, JavaScript for the UI component.",
          color: "#0071C5",
        },
        {
          title: "Graphic Designer",
          company: "BrandedKavita",
          company_url: "",
          logo_path: "kavita.svg",
          duration: "Nov 2020 - Dec 2020",
          location: "Work from Home",
          description:"This internship was provided by a Personal Brander Kavita. In this, my role was to create instagram posts and stories of the user which should have all the creativity and illustrations to enhance the content in it.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Workshops",
      experiences: [
        {
          title: "Pix it Up",
          company: "A Photoshop Workshop",
          company_url: "",
          logo_path: "photoshop.svg",
          duration: "Oct 2019",
          location: "Sipna College of Engineering and Technology",
          description:
            "In this workshop, we taught students what is photoshop software and make them familiar with the tools that are used to create posters, logo, or any other Graphic Element. This was a 2-day workshop and all the students were able to make posters or edit photos on their own using Adobe Photoshop.",
          color: "#4285F4",
        },
        {
          title: "Code the Web",
          company: "A HTML - CSS Workshop",
          company_url: "",
          logo_path: "css.svg",
          duration: "Feb 2020",
          location: "Sipna College of Engineering and Technology",
          description: "This was conducted by us to teach the students what they can create using just HTML and CSS. In this we first taught them some basics of both languages. Then we introduced them with CSS animations like hover effects, parallax effects, particle.js effects, etc. We also introduced some Javascript concepts as well.",
          color: "#196acf",
        },
        
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "Below are some of the projects that I have made. Click on the project to see the live demo.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "shikhar.jpg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I don't blog frequently but when I do something awesome, I do try to document it so it can be helpful to others. I write on Twitter.",
    link: "https://twitter.com/Harikrushn9",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      id: "0",
      name: "Live Corona Tracker",
      url: "https://livecoronatracker-01.netlify.app/",
      description: "This is a Corona Virus Tracker. It will show you country-wise corona updates. It has a map that display the area with most number of patients. Online API is used to fetch the live data.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
      ],
    },
    {
      id: "1",
      name: "Paper Todo App",
      url: "https://paper-todo-app.netlify.app/",
      description:
        "A React Paper Todo App UI with basic functionality such as create a task, set it as completed, clear the task. It also seperates the task according to completed or incompleted.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
      ],
    },
    // {
    //   id: "2",
    //   name: "node-blockchain",
    //   url: "https://github.com/harikanani/node-blockchain",
    //   description:
    //     "A simple blockchain and cryptocurrency wallet implemented in Node.js and TypeScript (for learning purposes).",
    //   languages: [
    //     {
    //       name: "NodeJS",
    //       iconifyClass: "logos-nodejs",
    //     },
    //     {
    //       name: "TypeScript",
    //       iconifyClass: "logos-typescript",
    //     },
    //   ],
    // },
    // {
    //   id: "3",
    //   name: "top-crypto-gainers",
    //   url: "https://github.com/harikanani/top-crypto-gainers",
    //   description:
    //     "A top high price changed crypto coins wring 24 hoursA sound-classifier webapp made with ReactJS + TensorflowJS.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "ReactJS",
    //       iconifyClass: "logos-react",
    //     },
    //   ],
    // },
    // {
    //   id: "4",
    //   name: "personal-portfolio",
    //   url: "https://github.com/harikanani/personal-portfolio",
    //   description:
    //     "A simple command line interface based quiz app to know more about me :).",
    //   languages: [
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "NodeJS",
    //       iconifyClass: "logos-nodejs",
    //     },
    //   ],
    // },
    // {
    //   id: "3",
    //   name: "node_express_crud_api_starter",
    //   url: "https://github.com/harikanani/node_express_crud_api_starter",
    //   description:
    //     "Simple NodeJS Express CRUD Operations API starter.",
    //   languages: [
    //     {
    //       name: "NodeJS",
    //       iconifyClass: "logos-nodejs",
    //     },
    //   ],
    // },
    // {
    //   id: "4",
    //   name: "node-web-scrapper",
    //   url: "https://github.com/harikanani/node-web-scrapper",
    //   description:
    //     "A Simple web scrapper that scrap the information of amazon products such as price.It also scrap Wikipedia Data such as birthdate.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //     {
    //       name: "NodeJs",
    //       iconifyClass: "logos-nodejs",
    //     },
    //   ],
    // },
    // {
    //   id: "5",
    //   name: "harikanani.github.io",
    //   url: "https://github.com/harikanani/harikanani.github.io",
    //   description:
    //     "A Personal Portfolio Website that showcases my work and experience. which is hosted on Github Pages.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "SCSS",
    //       iconifyClass: "vscode-icons:file-type-scss2",
    //     },
    //   ],
    // },
    // {
    //   id: "6",
    //   name: "Automate Attendace",
    //   url: "https://github.com/harikanani/Node_Python",
    //   description:
    //     "Automation of Online Attendance using node js and python",
    //   languages: [
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //   ],
    // },
    // {
    //   id: "7",
    //   name: "Automate Discord Bot",
    //   url: "https://github.com/harikanani/AutomateDiscordBot",
    //   description:
    //     "A Discord Bot to send Automatic messages to serer channel in regular time difference.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Python Selenium",
    //       iconifyClass: "logos-selenium",
    //     },
    //     {
    //       name: "Chromium Browser",
    //       iconifyClass: "openmoji-chromium",
    //     },
    //   ],
    // },
    // {
    //   id: "8",
    //   name: "Flask Blog",
    //   url: "https://github.com/harikanani/flask_blog",
    //   description:
    //     "A Simple Blog Web Application made using Flask Framework",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Flask",
    //       iconifyClass: "cib-flask",
    //     },
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //   ],
    // },
    // {
    //   id: "9",
    //   name: "Netflix top series",
    //   url: "https://github.com/harikanani/netflix-top-series",
    //   description:
    //     "List of Top Netflix Series which is deployed to vercel.",
    //   languages: [
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "ReactJS",
    //       iconifyClass: "logos-react",
    //     },
    //     {
    //       name: "HTML5",
    //       iconifyClass: "logos-html-5",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "logos-css-3",
    //     },
    //   ],
    // },
    // {
    //   id: "10",
    //   name: "COVID-19 Tracker",
    //   url: "https://github.com/harikanani/Covid19TrackerReact",
    //   description: "Simple Covid-19 Tracker made using React and deployed to Vercel.",
    //   languages: [
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "ReactJS",
    //       iconifyClass: "logos-react",
    //     },
    //     {
    //       name: "HTML5",
    //       iconifyClass: "logos-html-5",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "logos-css-3",
    //     },
    //   ],
    // },
    // {
    //   id: "11",
    //   name: "Food Order Static Website",
    //   url: "https://github.com/harikanani/food-order-website",
    //   description: "A simple static website related to food restaurants service. this is reasponsive as well.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "logos-html-5",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "logos-css-3",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "PHP",
    //       iconifyClass: "logos-php",
    //     },
    //   ],
    // },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
